function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgBee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M239.698,103.147c-2.667,0-5.286-1.289-6.874-3.675c-7.55-11.323-16.762-17.857-28.148-19.961 c-24.643-4.578-50.72,13.667-50.97,13.853c-3.715,2.644-8.865,1.765-11.507-1.942c-2.635-3.707-1.781-8.848,1.926-11.492 c1.289-0.926,31.887-22.458,63.453-16.665c15.827,2.902,28.945,11.999,38.979,27.053c2.53,3.796,1.507,8.913-2.289,11.443 C242.857,102.695,241.269,103.147,239.698,103.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M272.692,103.147c2.667,0,5.286-1.289,6.874-3.675c7.55-11.323,16.762-17.857,28.148-19.961 c24.643-4.578,50.72,13.667,50.97,13.853c3.715,2.644,8.865,1.765,11.507-1.942c2.635-3.707,1.781-8.848-1.926-11.492 c-1.289-0.926-31.887-22.458-63.453-16.665c-15.827,2.902-28.945,11.999-38.979,27.053c-2.53,3.796-1.507,8.913,2.289,11.443 C269.533,102.695,271.12,103.147,272.692,103.147z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585661"
    },
    d: "M313.957,136.154c0-27.345-25.861-49.511-57.763-49.511s-57.763,22.167-57.763,49.511"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD750"
    },
    cx: 256.189,
    cy: 317.695,
    rx: 107.274,
    ry: 132.029
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M162.677,253.12c-6.038,13.216-10.208,27.85-12.249,43.383 c16.827,7.666,48.138,18.084,105.763,18.084c57.632,0,88.944-10.422,105.769-18.088c-2.041-15.532-6.212-30.165-12.25-43.381 c-19.671,5.961-49.209,11.486-93.518,11.486C211.886,264.603,182.348,259.081,162.677,253.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M149.944,334.981c2.44,22.914,9.645,43.928,20.365,61.58c18.6,6.291,45.869,11.902,85.881,11.902 c40.019,0,67.292-5.613,85.891-11.906c10.719-17.652,17.922-38.666,20.363-61.579c-18.805,8.158-51.086,17.705-106.254,17.705 C201.029,352.683,168.749,343.138,149.944,334.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585661"
    },
    d: "M326.335,181.538c0,29.623-14.186,53.637-70.141,53.637s-70.141-24.014-70.141-53.637 s14.186-53.637,70.141-53.637S326.335,151.916,326.335,181.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M330.461,160.908c0,22.786-15.02,41.259-74.267,41.259s-74.267-18.473-74.267-41.259 s15.02-41.259,74.267-41.259S330.461,138.122,330.461,160.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEBD2"
    },
    d: "M470.742,259.931C339.744,138.216,313.57,130.48,313.57,130.48 c19.254,22.693,11.86,40.957,8.639,55.184c-16.504,72.891,14.441,117.589,33.007,132.029c39.73,30.9,156.785,69.109,156.785,41.259 C512,315.63,494.786,282.271,470.742,259.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDEB7"
    },
    d: "M483.595,274.056c-4.022-5.062-8.262-9.858-12.854-14.124c-2.657-2.468-5.201-4.815-7.772-7.19 c-26.761-5.794-62.742-13.56-81.27-17.385c-20.848-22.705-46.25-48.217-57.218-59.129c-0.505,2.223-1.047,4.371-1.557,6.434 c-0.236,0.973-0.509,2.085-0.716,3.002c-0.754,3.331-1.306,6.539-1.867,9.752c31.539,31.649,71.399,73.493,77.004,84.709 c3.049,6.098,14.491,41.828,20.357,69.805c0.014,0.005,0.028,0.011,0.042,0.016c5.965,2.288,11.987,4.453,17.957,6.426 c0.001,0.001,0.002,0.001,0.002,0.001c-5.358-31.159-19.773-75.986-23.596-83.63c-1.883-3.768-6.3-9.664-12.167-16.709 c30.301,6.398,65.61,14.065,82.979,17.85C483.146,273.94,483.369,273.999,483.595,274.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEBD2"
    },
    d: "M41.259,259.931C172.257,138.216,198.431,130.48,198.431,130.48 c-19.254,22.693-11.86,40.957-8.639,55.184c16.504,72.891-14.441,117.589-33.007,132.029C117.055,348.593,0,386.803,0,358.953 C0,315.63,17.214,282.271,41.259,259.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDEB7"
    },
    d: "M28.405,274.056c4.022-5.062,8.262-9.858,12.854-14.124c2.657-2.468,5.201-4.815,7.772-7.19 c26.761-5.794,62.742-13.56,81.27-17.385c20.848-22.705,46.25-48.217,57.218-59.129c0.505,2.223,1.047,4.371,1.557,6.434 c0.236,0.973,0.509,2.085,0.716,3.002c0.754,3.331,1.306,6.539,1.867,9.752c-31.539,31.649-71.399,73.493-77.004,84.709 c-3.049,6.098-14.491,41.828-20.357,69.805c-0.014,0.005-0.028,0.011-0.042,0.016c-5.965,2.288-11.987,4.453-17.957,6.426 l-0.003,0.001c5.359-31.159,19.775-75.986,23.597-83.63c1.883-3.768,6.3-9.664,12.167-16.709 c-30.301,6.398-65.61,14.065-82.979,17.85C28.854,273.94,28.632,273.999,28.405,274.056z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBee);
export default __webpack_public_path__ + "static/media/bee.675e849f.svg";
export { ForwardRef as ReactComponent };